import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import { REGIONS } from '@/modules/region/domain/region';
import { PLAN_TYPES } from '@/modules/subscription/domain/subscription-plan-types';
export const COACHING_PLAN_IDS = Object.freeze({
    oneWeek: 'coaching-subscription-one-week',
    fourWeeks: 'coaching-subscription-four-week',
    twelveWeeks: 'coaching-subscription-twelve-week',
});
export const COACHING_BACKOFFER_PLAN_IDS = Object.freeze({
    oneWeek: 'coaching-subscription-backoffer-one-week',
    fourWeeks: 'coaching-subscription-backoffer-four-week',
    twelveWeeks: 'coaching-subscription-backoffer-twelve-week',
});
export function getCoachingPlanId(planType, { downsale = false } = {}) {
    const planIds = downsale ? COACHING_BACKOFFER_PLAN_IDS : COACHING_PLAN_IDS;
    const planId = planIds[planType];
    if (!planId) {
        throw new Error(`Invalid plan type: ${planType}. Expected one of: ${Object.keys(COACHING_PLAN_IDS).join(', ')}`);
    }
    return planId;
}
const coachMuscleChargeUpsell = {
    [REGIONS.us]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '39.99',
            newPrice: '19.99',
            renewalPrice: '99.99',
            discount: '50%',
            subscriptionFee: '99.99',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '99.99',
            newPrice: '49.99',
            renewalPrice: '99.99',
            discount: '50%',
            subscriptionFee: '99.99',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '199.99',
            newPrice: '99.99',
            renewalPrice: '199.99',
            discount: '50%',
            subscriptionFee: '199.99',
        },
    },
    [REGIONS.uk]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.49',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '59.99',
            newPrice: '29.99',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '179.99',
            newPrice: '89.99',
            renewalPrice: '179.99',
            discount: '50%',
            subscriptionFee: '179.99',
        },
    },
    [REGIONS.eu]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.49',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '59.99',
            newPrice: '29.99',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '179.99',
            newPrice: '89.99',
            renewalPrice: '179.99',
            discount: '50%',
            subscriptionFee: '179.99',
        },
    },
    [REGIONS.join]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.49',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '59.99',
            newPrice: '29.99',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '179.99',
            newPrice: '89.99',
            renewalPrice: '179.99',
            discount: '50%',
            subscriptionFee: '179.99',
        },
    },
    [REGIONS.latam]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.49',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '59.99',
            newPrice: '29.99',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '179.99',
            newPrice: '89.99',
            renewalPrice: '179.99',
            discount: '50%',
            subscriptionFee: '179.99',
        },
    },
    // Other regions can be added here as needed
    // [REGIONS.au]: { ... },
};
const coachReverseHealthUpsell = {
    [REGIONS.mx]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '276',
            newPrice: '138',
            renewalPrice: '999',
            discount: '50%',
            subscriptionFee: '999',
            downsalePrice: '86',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '1038',
            newPrice: '519',
            renewalPrice: '999',
            discount: '50%',
            subscriptionFee: '999',
            downsalePrice: '346',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '3118',
            newPrice: '1559',
            renewalPrice: '2999',
            discount: '50%',
            subscriptionFee: '2999',
            downsalePrice: '999',
            downsaleDiscount: '70%',
        },
    },
    [REGIONS.us]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '39.99',
            newPrice: '19.99',
            renewalPrice: '99.99',
            discount: '50%',
            subscriptionFee: '99.99',
            downsalePrice: '9.99',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '99.99',
            newPrice: '49.99',
            renewalPrice: '99.99',
            discount: '50%',
            subscriptionFee: '99.99',
            downsalePrice: '29.99',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '199.99',
            newPrice: '99.99',
            renewalPrice: '199.99',
            discount: '50%',
            subscriptionFee: '199.99',
            downsalePrice: '79.99',
            downsaleDiscount: '70%',
        },
    },
    [REGIONS.uk]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.49',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
            downsalePrice: '4.49',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '59.99',
            newPrice: '29.99',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
            downsalePrice: '19.99',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '179.99',
            newPrice: '89.99',
            renewalPrice: '179.99',
            discount: '50%',
            subscriptionFee: '179.99',
            downsalePrice: '59.99',
            downsaleDiscount: '70%',
        },
    },
    [REGIONS.join]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.49',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
            downsalePrice: '4.49',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '59.99',
            newPrice: '29.99',
            renewalPrice: '59.99',
            discount: '50%',
            subscriptionFee: '59.99',
            downsalePrice: '19.99',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '179.99',
            newPrice: '89.99',
            renewalPrice: '179.99',
            discount: '50%',
            subscriptionFee: '179.99',
            downsalePrice: '59.99',
            downsaleDiscount: '70%',
        },
    },
    [REGIONS.eu]: {
        [PLAN_TYPES.oneWeek]: {
            oldPrice: '14.99',
            newPrice: '7.99',
            renewalPrice: '29.99',
            discount: '50%',
            subscriptionFee: '29.99',
            downsalePrice: '4.49',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.fourWeeks]: {
            oldPrice: '29.99',
            newPrice: '14.99',
            renewalPrice: '29.99',
            discount: '50%',
            subscriptionFee: '29.99',
            downsalePrice: '11.99',
            downsaleDiscount: '70%',
        },
        [PLAN_TYPES.twelveWeeks]: {
            oldPrice: '99.99',
            newPrice: '49.99',
            renewalPrice: '99.99',
            discount: '50%',
            subscriptionFee: '99.99',
            downsalePrice: '39.99',
            downsaleDiscount: '70%',
        },
    },
};
const coachUpsellPricesByBrand = {
    [PROJECT_BRANDS.muscleCharge]: coachMuscleChargeUpsell,
    [PROJECT_BRANDS.reverse]: coachReverseHealthUpsell,
};
/**
 * Get coach upsell price by brand, region and plan type
 * @param {Object} params - Function parameters
 * @param {string} params.brand - The brand identifier (e.g., 'ReverseHealth', 'MuscleCharge')
 * @param {string} params.region - The user's region (e.g., 'US', 'UK', 'EU')
 * @param {string} params.planType - The user's subscription plan type (oneWeek, fourWeeks, twelveWeeks)
 * @returns {Object} Price configuration for the given brand, region and plan type
 * @throws {Error} If brand, region or plan type is invalid
 */
export function getCoachPrice({ region, planType, brand }) {
    const brandPrices = coachUpsellPricesByBrand[brand];
    if (!brandPrices) {
        throw new Error(`Invalid brand: ${brand}. Expected one of: ${Object.keys(coachUpsellPricesByBrand).join(', ')}`);
    }
    const regionPrices = brandPrices[region];
    if (!regionPrices) {
        const availableRegions = Object.keys(brandPrices).join(', ');
        throw new Error(`Invalid region: ${region} for brand ${brand}. Expected one of: ${availableRegions}`);
    }
    const price = regionPrices[planType];
    if (!price) {
        throw new Error(`Invalid plan type: ${planType}. Expected one of: ${Object.keys(PLAN_TYPES).join(', ')}`);
    }
    return price;
}
